/**
 * Get the environment of the current server. ONLY FOR SERVER SIDE.
 */
export const getEnvironment = () => {
  const isDev = process.env.NODE_ENV === 'development';
  const isPreview = process.env.VERCEL_ENV === 'preview';

  return isDev ? 'development' : isPreview ? 'preview' : 'production';
};

export function isEnvironment(...args: ReturnType<typeof getEnvironment>[]) {
  return args.includes(getEnvironment());
}
